import React from 'react';
import { Spinner } from 'reactstrap';

import './style.scss';
const ContextLoader = ({ isLoading, loadingMessage, children }) => {
    if (!!isLoading ) {
        return (
            <div className='context-loader' title={loadingMessage || 'Carregando...'}>
                <Spinner size="lg" color="primary"/>
            </div>
        );
    }

    return <React.Fragment>{children}</React.Fragment>;

};

export { ContextLoader };

